import OfferComparison from './offer-comparison';

export default OfferComparison;
